import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useKeycloak } from "@react-keycloak/web";
import { api } from "../../services/api/api";

/**
 * Composant d'initialisation globale de la langue utilisateur
 * 
 * @param props - Les propriétés du composant
 * @param props.children - Les composants enfants à rendre après l'initialisation
 * @returns Les composants enfants une fois la langue initialisée
 */
export default function LanguageInitializer({ children }: { children: React.ReactNode }) {
  const { keycloak } = useKeycloak();
  const { i18n } = useTranslation();
  const [languageInitialized, setLanguageInitialized] = useState(false);

  useEffect(() => {
    const initializeUserLanguage = async () => {
      if (languageInitialized || !keycloak.authenticated || !keycloak.tokenParsed?.sub) {
        return;
      }

      try {
        const user = await api.get(`admin/users/${keycloak.tokenParsed.sub}`) as EasyTech.User;
        
        if (user?.language?.isoCode) {
          await i18n.changeLanguage(user.language.isoCode);
          localStorage.setItem("i18nextLng", user.language.isoCode);
        }
        
        setLanguageInitialized(true);
      } catch (error) {
        console.error("Erreur lors de l'initialisation de la langue utilisateur:", error);
        setLanguageInitialized(true);
      }
    };

    initializeUserLanguage();
  }, [keycloak.authenticated, keycloak.tokenParsed?.sub, i18n, languageInitialized]);

  if (!keycloak.authenticated || languageInitialized) {
    return <>{children}</>;
  }

  return <>{children}</>;
} 